import React, { useContext, useState } from 'react';
import { AdvancedMarker, APIProvider, Map } from '@vis.gl/react-google-maps';
import ConfigContext from '../../../contexts/ConfigContext';

import MapPin from './MapPin';

import styles from './SearchMap.module.postcss';

const isValidCoordinate = (lat, lng) =>
  typeof lat === 'number' && typeof lng === 'number' && !Number.isNaN(lat) && !Number.isNaN(lng);

function SearchMap({ searchResults, hoverLocation, setFilters }) {
  const { latitude, longitude, gmKey } = useContext(ConfigContext);
  const defaultCenter = { lat: latitude, lng: longitude };

  const [mapBounds, setMapBounds] = useState();
  const [searchMapDisabled, setSearchMapDisabled] = useState(false);

  const locations = searchResults ?
    Object.groupBy(
      searchResults,
      ({ location_id }) => location_id
    ) : [];

  const handleCameraChange = (event) => {
    const { detail: { bounds } } = event;
    if (bounds) {
      setSearchMapDisabled(false);
      setMapBounds({
        sw: { lat: bounds.south, lng: bounds.west },
        ne: { lat: bounds.north, lng: bounds.east },
      });
    }
  };

  const handleSearchInMap = () => {
    if (mapBounds) {
      setSearchMapDisabled(true);
      setFilters({
        sw_lat: mapBounds.sw.lat,
        sw_lng: mapBounds.sw.lng,
        ne_lat: mapBounds.ne.lat,
        ne_lng: mapBounds.ne.lng,
      });
    }
  };

  return (
    <div className={styles.SearchMap}>

      <APIProvider apiKey={gmKey}>
        <Map
          defaultCenter={defaultCenter}
          defaultZoom={11}
          mapId='SEARCH_MAP'
          disableDefaultUI
          onCameraChanged={handleCameraChange}
        >
          { Object.values(locations)
            .filter((location) => isValidCoordinate(location[0].latitude, location[0].longitude))
            .map((location) => {
              const locationCenter = {
                lat: location[0].latitude,
                lng: location[0].longitude,
              };

              return (
                <AdvancedMarker position={locationCenter} key={location[0].location_id}>
                  <MapPin
                    location={location}
                    hover={hoverLocation === location[0].location_id}
                  />
                </AdvancedMarker>
              );
            }) }
        </Map>

        <button
          type='button'
          className={styles.SearchMap_Redo + ' Button'}
          onClick={handleSearchInMap}
          disabled={searchMapDisabled}
        >
          Redo search in map
        </button>
      </APIProvider>
    </div>
  );
}

export default SearchMap;
